import type { Errors } from "~/types/error"
import type { SupabaseSSRClientType } from "./createSbClientSSR"

export const NOT_ALOOW_INPUT = "not allowed input"
export const INVALID_TYPE = "Invalid type"
export const EMAIL_NOT_CONFIRMED = "Email not confirmed"
export const INVALID_LOGIN_CREDENTIALS = "Invalid login credentials"
export const EMAIL_IS_REQUIRED = "email is required"
export const INVALID_EMAIL = "invalid email"
export const PASSWORD_IS_SHORTER_THAN_8_CHARACTERS = "password is shorter than 8 characters"
export const PASSWORD_IS_REQUIRED = "password is required"
export const EXIST_USER = "exist user"
export const INVALID_CODE = "Invalid promo code"

export const ErrorUtils = {
  getErrorTextDisplay: (type: string, message: string | undefined): string => {
    if (type === "validation") {

      switch (message) {
        case "Invalid URL":
          return "URLが不正です。"
        case "Invalid type":
          return "入力してください。"
        default:
          return message ?? "エラーが発生しました。"
      }
    }

    switch (message) {
      case "New password should be different from the old password.":
        return "新しいパスワードは古いパスワードと異なる必要があります。"
      case "Invalid type":
        return "入力してください。"
      case "Email not confirmed":
        return "メールアドレスが確認されていません。"
      case "Invalid login credentials":
        return "メールアドレスまたはパスワードが間違っています。"
      case "email is required":
        return "メールアドレスは必須です。"
      case "invalid email":
        return "メールアドレスが不正です。"
      case "password is shorter than 8 characters":
        return "パスワードは8文字以上で入力してください。"
      case "password is required":
        return "パスワードは必須です。"
      case "exist user":
        return "既に登録されているメールアドレスです。"
      case "not allowed input":
        return "入力された値が不正です。"
      case "coompany name required":
        return "法人名は必須です。"
      case INVALID_CODE:
        return "無効なプロモーションコードです。"
      case "select plan required":
        return "プランを選択してください。"
      default:
        return "エラーが発生しました。"
    }
  }
}

export const errorToArray = (error: Errors) => {
  return Object.entries(error).reduce<string[]>((prev, el, i) => {
    if (Array.isArray(el[1])) {
      el[1].forEach((e) => {
        const text = ErrorUtils.getErrorTextDisplay(el[0], e)
        prev.push(text)
      })
    } else {
      if (el[1]) {
        const text = ErrorUtils.getErrorTextDisplay(el[0], el[1])
        prev.push(text)
      }
    }
    return prev
  }, [])
}

export class RemixError extends Error {
  status: number | undefined
  protected __isRemixError = true
  constructor(message: string, status?: number) {
    super(message)
    this.name = 'RemixError'
    this.status = status
  }
}

export class CustomRemixError extends RemixError {
  name: string
  status: number
  constructor(message: string, name: string, status: number) {
    super(message)
    this.name = name
    this.status = status
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
    }
  }
}


export const signUp = async (supabase: SupabaseSSRClientType, {
  email,
  password,
}: {
  email: string
  password: string
}, siteURL: string
) => {
  const response = await supabase.auth.signUp({
    email: email as string,
    password: password as string,
    options: {
      emailRedirectTo: siteURL + "/auth/callback",
    },
  });
  return response
}